import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const register = (data) => api.post('/auth/register', data);
export const login = (data) => api.post('/auth/login', data);
export const verify2FA = (userId, code) => api.post(`/auth/verify-2fa?user_id=${userId}&code=${code}`);
export const getMe = () => api.get('/auth/me');

// 2FA
export const setup2FA = () => api.post('/2fa/setup');
export const verify2FASetup = (code) => api.post('/2fa/verify', { totp_code: code });
export const disable2FA = (code) => api.post('/2fa/disable', { totp_code: code });

// Wallet
export const getBalance = () => api.get('/wallet/balance');
export const getDepositAddress = () => api.get('/wallet/deposit-address');
export const requestDeposit = (data) => api.post('/wallet/deposit', data);
export const requestWithdraw = (data) => api.post('/wallet/withdraw', data);
export const getTransactions = () => api.get('/wallet/transactions');
export const getPayBalance = () => api.get('/wallet/pay-balance');
export const requestPayWithdraw = (data) => api.post('/wallet/withdraw-pay', data);

// Investments
export const getInvestments = () => api.get('/investments');
export const createInvestment = (data) => api.post('/investments', data);
export const getInvestmentPlans = () => api.get('/investments/plans');

// Loans
export const getLoans = () => api.get('/loans');
export const createLoan = (data) => api.post('/loans', data);
export const repayLoan = (loanId) => api.post(`/loans/${loanId}/repay`);

// Game
export const playGame = (data) => api.post('/game/play', data);
export const getGameRewards = () => api.get('/game/rewards');
export const getPlaysRemaining = () => api.get('/game/plays-remaining');
export const getGameStats = () => api.get('/game/stats');
export const getGameHistory = () => api.get('/game/history');

// Referral
export const getReferralStats = () => api.get('/referral/stats');
export const validateReferralCode = (code) => api.get(`/referral/validate/${code}`);

// Admin
export const getPendingTransactions = () => api.get('/admin/pending-transactions');
export const processTransaction = (id, data) => api.post(`/admin/transaction/${id}`, data);
export const getFraudAlerts = () => api.get('/admin/fraud-alerts');
export const resolveFraudAlert = (id) => api.post(`/admin/fraud-alerts/${id}/resolve`);
export const getAdminStats = () => api.get('/admin/stats');
export const getAllUsers = () => api.get('/admin/users');
export const toggleAdmin = (userId) => api.post(`/admin/users/${userId}/toggle-admin`);
export const adjustBalance = (userId, amount) => api.post(`/admin/users/${userId}/adjust-balance?amount=${amount}`);
export const getAIHouseEdge = () => api.get('/admin/ai/house-edge');
export const getAllAccounts = () => api.get('/admin/accounts');
export const getEarnedPaycoins = () => api.get('/admin/earned-paycoins');
export const transferPayToUser = (userId, data) => api.post(`/admin/users/${userId}/transfer-pay`, data);

export default api;
